interface IMode {
  mode: string | "VIEW";
}

const AddEditViewUser = (props: IMode) => {
  if (props.mode === "ADD") {
    return <div>Add User</div>;
  } else if (props.mode === "EDIT") {
    return <div>Edit User</div>;
  } else {
    return <div>View User</div>;
  }
};

export default AddEditViewUser;
